import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getPagesList = (pageData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAGES_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/pages-version/list`,
        pageData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PAGES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PAGES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PAGES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// GET VERSIONS BY TYPE
export const getPagesVersionsByType = (type, body = {}) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAGES_VERSIONS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/pages-version/versions/${type}`,
        body,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PAGES_VERSIONS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PAGES_VERSIONS_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_PAGES_VERSIONS_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// ADD PAGE
export const addPages = (pageData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_PAGE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/pages-version/add`,
        pageData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PAGE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "ADD_PAGE_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "ADD_PAGE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// VIEW PAGE
export const viewPage = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_PAGE_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/pages-version/view/${id}`);
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_PAGE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_PAGE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_PAGE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// UPDATE PAGE
export const updatePage = (id, pageData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_PAGE_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/pages-version/update/${id}`,
        pageData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_PAGE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_PAGE_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "UPDATE_PAGE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

// DELETE PAGE
export const deletePage = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "DELETE_PAGE_REQUEST" });
      const { data } = await axios.delete(
        `${BASE_URL}/pages-version/remove/${id}`
      );
      if (data.statusCode === 200) {
        dispatch({ type: "DELETE_PAGE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "DELETE_PAGE_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "DELETE_PAGE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const getAccessCode = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ACCESS_CODE_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/admin/access-code/${id}`);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_ACCESS_CODE_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_ACCESS_CODE_FAILED", payload: data });
      }
      return data;
    } catch (error) {
      dispatch({
        type: "GET_ACCESS_CODE_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
